<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>服务站</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                            :value="item.id + ''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="服务站名称">
                    <el-input v-model="listQuery.stationName" placeholder="请输入服务站名称" clearable></el-input>
                </el-form-item>

                <el-form-item label="类型">
                    <el-select v-model="listQuery.type" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in typeKey" :key="index" :label="item" :value="index + ''">
                        </el-option>
                    </el-select>
                </el-form-item>
               

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button v-per="'addstation'" type="primary" class="el-icon-plus" plan @click="addStation">新增服务站
                    </el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="stationAddress" label="城市"></el-table-column>
                <el-table-column prop="postStationId" label="驿站">
                    <template slot-scope="scope">
                        <span style="">{{ getPostStation(scope.row.postStationId) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="stationName" label="服务站名称"></el-table-column>
                <el-table-column prop="stationCode" label="服务站编号"></el-table-column>
                <el-table-column prop="type" label="服务站归属">
                    <template slot-scope="scope">
                        <span>{{ typeKey[scope.row.type] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="buzType" label="服务站类型">
                    <template slot-scope="scope">
                        <span style="color:orange;">{{ buzTypeKey[scope.row.buzType] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="stationAdminName" label="站长">
                    <template slot-scope="scope">
                        <span style="color:blue;">{{ scope.row.stationAdminName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="houseName" label="关联仓库">
                    <template slot-scope="scope">
                        <span style="color:green;">{{ scope.row.houseName }}</span>
                    </template>
                </el-table-column>
                 
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">

                        <el-button v-per="'drawServiceRegionP'" type="text" @click="drawServiceRegion(scope.row)">服务区域设置
                        </el-button>
                        <el-button v-per="'updatestation'" type="text" icon="el-icon-edit"
                            @click="handleEditStation(scope.row)">编辑服务站</el-button>
                        <el-button v-per="'updatestationadmin'" type="text" icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)">修改站长</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="修改站长" :visible.sync="showUpdate" width="400px" :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="服务站">
                    <el-input style="width:190px;" disabled v-model="updateAdmin.stationName"></el-input>
                </el-form-item>
                <el-form-item label="站长">
                    <el-select v-model="updateAdmin.stationAdminId" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in sysUserList" :key="index" :label="item.userName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showUpdate = false">关闭</el-button>
                <el-button type="primary" @click="saveUpdate">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="addFrom.id ? '编辑' : '新增服务站'" :visible.sync="showAdd" width="400px"
            :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="类型">
                    <el-select v-model="addFrom.type" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in typeKey" :key="index" :label="item" :value="index + ''">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="业务类型">
                    <el-select v-model="addFrom.buzType" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in buzTypeKey" :key="index" :label="item" :value="index + ''" >
                        </el-option>
                    </el-select>
                </el-form-item>
             
                <el-form-item label="城市">
                    <el-select v-model="addFrom.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                            :value="item.id + ''"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="驿站">
                    <el-select v-model="addFrom.postStationId" clearable placeholder="请选择驿站" filterable>
                        <template v-for="(item, index) in postStationList">
                            <el-option :key="index" v-if="item.cityId == addFrom.cityId" :label="item.postStationName"
                                :value="item.id + ''"> </el-option>
                        </template>
                        <!-- <el-option v-for="(item,index) in postStationList" :key="index" :label="item.postStationName" :value="item.id+''"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item label="服务站名称">
                    <el-input style="width:180px;" clearable v-model="addFrom.stationName"></el-input>
                </el-form-item>
                <el-form-item label="服务站编码">
                    <el-input style="width:180px;" clearable v-model="addFrom.stationCode"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showAdd = false">关闭</el-button>
                <el-button type="primary" @click="saveStation">提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            typeKey: { 1: "自营", 2: "盒马" }, 
            buzTypeKey: { 1: '保洁站', 2: '品类站', 3: '综合站', 4: '中介类服务站', 5: '改约服务站', 6: '保姆站' },
            listData: [],
            cityList: [],
            postStationList: [],
            sysUserList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                cityId: "",
                stationName: "",
                type: null 
            },
            updateAdmin: {
                stationId: "",
                stationName: "",
                stationAdminId: "" 
            },
            addFrom: {
                type: "1",
                buzType:1,//1保洁站、2品类站、3综合站、4中介类服务站、5改约服务站、6保姆站
                cityId: null,
                postStationId: null,
                stationName: null,
                stationCode: null 
            },
            showUpdate: false,
            showAdd: false,
        };
    },

    created() {
        this.getAllCity();
        this.getAllPostStation();

        this.querySearch();
    },
    methods: {
        //绘制区域
        drawServiceRegion(row) {
            this.$router.push({
                path: "/drawServiceRegionP",
                query: {
                    unitId: row.id,
                }
            });
        },
        handleDel(row) {
            this.$confirm("是否确认删除?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    service
                        .$axiosDeleteStation({
                            id: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        handleEditStation(row) {
            this.showAdd = true;
            this.addFrom = {
                id: row.id,
                type: row.type + '',
                buzType:row.buzType+'',
                cityId: row.cityId + '',
                postStationId: row.postStationId + '',
                stationName: row.stationName,
                stationCode: row.stationCode 
            };
            console.log(this.addFrom);
        },
        addStation() {
            this.showAdd = true;
            this.addFrom = {
                type: "1",
                cityId: null,
                postStationId: null,
                stationName: null,
                stationCode: null,
            };
        },
        handleEdit(index, row) {
            this.tempRow = row;
            this.getSysUser();
            this.showUpdate = true;

            this.updateAdmin = {
                stationId: row.id,
                stationName: row.stationName,
                stationAdminId: row.stationAdminId,
            };
        },
        saveStation() {
            crmApi.$ajaxAddstation(this.addFrom).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showAdd = false;
                    this.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        saveUpdate() {
            service.$axiosUpdateStationAdmin(this.updateAdmin).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showUpdate = false;
                    this.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            service.$axiosGetStationPageList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getAllPostStation() {
            crmApi.$axiosPostStationgetAllList().then((res) => {
                if (res.data.errno == 0) {
                    this.postStationList = res.data.data;
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getSysUser() {
            service.$axiosSysUsergetallUser().then((res) => {
                if (res.data.errno == 0) {
                    this.sysUserList = res.data.data;
                }
            });
        },
        getPostStation(id) {
            let nm = null;
            this.postStationList.forEach((e) => {
                if (e.id == id) {
                    nm = e.postStationName;
                }
            });
            return nm;
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>